<template>
  <div class="user content-box">
    <div class="banner">
      <img
        src="~@/assets/images/user_banner.jpg"
        srcset="
          ~@/assets/images/user_banner.jpg    1x,
          ~@/assets/images/user_banner@2x.jpg 2x
        "
        alt="banner"
      />
    </div>
    <div class="content-normal">
      <div class="account">
        <div
          class="avatar"
          :style="{ backgroundImage: `url(${user.avatar_url})` }"
        ></div>
        <h5>{{ user.real_name }}</h5>
        <p>{{ user.unit_name }}</p>
      </div>
      <ul class="info-list">
        <li>
          <h5>
            <span class="header-icon">
              <info-icon />
            </span>
            个人信息
          </h5>
          <div>
            <ul class="user-info">
              <li>
                <div class="left">
                  <span>用户名：</span>
                  {{ user.real_name }}
                </div>
                <a href="javascript:;"></a>
              </li>
              <li>
                <div class="left">
                  <span>手机号：</span>
                  {{ user.parent_mobile }}
                </div>
                <router-link class="right" :to="{ name: 'phone' }"
                  >更换手机号</router-link
                >
              </li>
            </ul>
          </div>
        </li>
        <li>
          <h5>
            <span class="header-icon">
              <class-icon />
            </span>
            任课老师及班级
          </h5>
          <div>
            <ul class="class-info">
              <li v-for="v of classData" :key="v.id">
                <span>{{ v.teacher_name }}</span>
                <span>{{ v.class_name }}</span>
              </li>
            </ul>
          </div>
        </li>
        <li>
          <h5>
            <span class="header-icon">
              <tips-icon />
            </span>
            小贴士
          </h5>
          <div>
            <p v-if="!fromSchool" class="mb-0">
              家长您好！如有问题，请直接发送消息给此公众号。或联系点猫编程平台产品经理QQ：2132425655
            </p>
            <p v-else class="mb-0">
              如有疑问，请关注微信公众号【编程猫学院】，或联系喵主任QQ：2241731635
            </p>
          </div>
        </li>
      </ul>
      <p @click="logout" class="text-center cursor-pointer fs-16">取消关联</p>
    </div>
  </div>
</template>
<script>
import InfoIcon from "@/assets/svg/icon_info.svg";
import ClassIcon from "@/assets/svg/icon_class.svg";
import TipsIcon from "@/assets/svg/icon_tips.svg";
import { mapState, mapActions } from "vuex";
import { post } from "@/utils/ajax";
export default {
  created() {
    this.refresh();
  },
  computed: {
    ...mapState({
      user: (state) => state.user || {},
      classData: "classData",
    }),
    fromSchool() {
      return this.$store.state.fromSchool;
    },
  },
  methods: {
    ...mapActions(["getCodemaoUserInfo", "getClassList"]),
    refresh() {
      this.getCodemaoUserInfo();
      this.getClassList();
    },
    async logout() {
      // 学生已经绑定过手机号退出后登录按钮由下一步改为登录
      // if (this.user.parent_mobile) {

      // }
      // 先取消B端的关联，再退出登录
      if (process.env.NODE_ENV !== "production") {
        if (!this.$store.state.isWeixin) {
          return this.$store.dispatch("logout");
        }
      }
      await post("/edu/wap/profiles/exit");
      this.$store.dispatch("logout");
    },
  },
  components: {
    InfoIcon,
    ClassIcon,
    TipsIcon,
  },
};
</script>

<style lang="stylus" scoped>
.banner
  img
    width 100%
.content-normal
  top -34px
.account
  padding-top 52px
  border-radius 8px
  box-shadow 0 0 12px 0 rgba(101, 113, 117, 0.1)
  background-color white
  height 115px
  margin-bottom 30px
  h5
    text-align center
    font-size 16px
    font-weight bold
    margin-bottom 10px
    color #333
  p
    text-align center
.avatar
  round(88px)
  border 3px solid white
  background-color #ccc
  background-cover()
  top -44px
  left 50%
  margin-left -44px
  position absolute
.info-list
  > li
    padding-left 34px
    position relative
    margin-bottom 20px
    > div
      padding-bottom 17px
      // border-1('%23f6f6f6', bottom)
      border-bottom 1px solid #f6f6f6
  h5
    line-height 24px
    font-size 16px
    color #333
    font-weight normal
.user-info
  li
    display flex
    justify-content space-between
.class-info
  li
    display flex
  span
    flex-grow 1
.header-icon
  position absolute
  width 24px
  height 24px
  left 0
  top 0
</style>
